import { Colors } from '../consts/Colors';
import ButtonArrow from './buttons/ButtonArrow.js';

export default class LevelBtn extends Phaser.GameObjects.Container {
    constructor(scene, x, y, level) {
        super(scene, x, y);
        scene.add.existing(this);
        this.scene = scene;
        this.level = level;

        let illu
        let btnTxt
        let txt
        if (this.level === 0) {
            illu = 'ctaDebutant'
            btnTxt = 'Débutant'
            txt = '6 - 8 ans'
        } else {
            illu = 'ctaExpert'
            btnTxt = 'Expert'
            txt = "9 - 11 ans"
        }

        console.log('LevelBtn', this.level, illu, btnTxt, txt);

        this.backImage = this.scene.add.image(0, 0, illu).setOrigin(0.5).setScale(0).setAlpha(0);
        this.add(this.backImage);

        this.btn = new ButtonArrow(this.scene, 0, 80, 190, 60, btnTxt, "24px");
        this.btn.setScale(0).setAlpha(0);
        this.add(this.btn);

        this.btn.setClickFunction(() => {
            this.scene.game.data.currentLevel = this.level;
            this.scene.scene.start('IntroVideo', { level: this.level });
        })

        this.text = this.scene.add.rexTagText(0, 140, txt, {
            fontSize: "32px",
            fontFamily: "Monteserrat",
            align: "center",
            color: Colors.Text.White,
            backgroundColor: 'transparent',
        }).setOrigin(0.5).setScale(0).setAlpha(0);

        this.add(this.text);




    }

    launchAnim() {
        this.scene.tweens.add({
            targets: this.backImage,
            duration: 300,
            ease: 'Back.easeOut',
            scale: 1,
            alpha: 1,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this.btn,
                    duration: 300,
                    ease: 'Back.easeOut',
                    scale: 1,
                    alpha: 1,
                    onComplete: () => {
                        this.scene.tweens.add({
                            targets: this.text,
                            duration: 300,
                            ease: 'Back.easeOut',
                            scale: 1,
                            alpha: 1,
                        });
                    }
                });
            }
        });
    }
}
